import React, { useState, useEffect } from 'react';
import { usePWA } from '../hooks/usePWA';
import { getEnvironmentConfig, isTelegramEnvironment } from '../utils/environment';

const PWAInstallPrompt: React.FC = () => {
  const { installApp } = usePWA();
  const { showInstallPrompt } = getEnvironmentConfig();
  const isAuthenticated = localStorage.getItem('authToken') !== null;
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const checkViewport = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkViewport();
    window.addEventListener('resize', checkViewport);
    
    return () => window.removeEventListener('resize', checkViewport);
  }, []);

  useEffect(() => {
    // Add data attribute to body on mount/visibility change
    document.body.setAttribute('data-pwa-visible', isVisible.toString());
    
    return () => {
      // Remove attribute on unmount
      document.body.removeAttribute('data-pwa-visible');
    };
  }, [isVisible]);

  // Check if we're on PWA domain
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isPWADomain = hostname === 'pwa.secondlane.io' || hostname === 'dev-pwa.secondlane.io' || hostname === 'localhost' || hostname === '127.0.0.1';

  // Don't show the prompt if:
  // 1. Not on PWA domain
  // 2. showInstallPrompt is false (not in browser environment)
  // 3. User is already authenticated
  // 4. Screen width is greater than 768px (desktop)
  // 5. User has dismissed the prompt
  // 6. App is running in Telegram (explicit check)
  // 7. User is on landing pages
  const currentHash = window.location.hash;
  const isOnLandingPage = currentHash === '#/landing' || currentHash === '#/pwa-landing';
  
  if (!isPWADomain || !showInstallPrompt || isAuthenticated || !isMobile || !isVisible || isTelegramEnvironment() || isOnLandingPage) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm z-50">
      <div className="max-w-[600px] mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-700">
            Install SecondLane App for quick access
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={installApp}
            className="bg-[#4B4F47] hover:bg-[#3a3d36] text-white text-sm px-3 py-1 rounded-lg transition-colors whitespace-nowrap font-medium"
          >
            Install
          </button>
          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-500 hover:text-gray-700 p-1"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;